import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgxNumberBoxFilter} from "./ngx-number-box-filter";
import {Filter, FilterNumberBoxOptions} from "../../ngx-types";

@Component({
  selector: 'number-box',
  templateUrl: './number-box.component.html',
  styleUrls: ['./number-box.component.scss']
})
export class NumberBoxComponent extends NgxNumberBoxFilter implements OnInit {
  @Input() filter: Filter;
  @Input() options: FilterNumberBoxOptions;
  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();
  @Input() label: string;

  ngOnInit(): void {
  }

}
